// An application can have a text of its own: the translation `<id>_<code>_<version>`
// of the code and the version of the application, or `<id>_<code>` of the code
// alone. The other applications, and the other versions of the same code, keep
// the common text `<id>`.
export const applicationMessageId = (messages, id, code, version) => {
  const candidates = [`${id}_${code}_${version}`, `${id}_${code}`];

  return code ? candidates.find((candidate) => messages?.[candidate]) || id : id;
};

// The screens of one application can differ (what the customer needs, the fields
// to fill in), so a screen can have a text of its own on top of that:
// `<id>_<code>_<version>_<step>`. Without one the text of the application above
// is used, so an application that has no text per screen shows what it showed.
export const applicationStepMessageId = (messages, id, code, version, step) => {
  const ownId = `${id}_${code}_${version}_${step}`;

  return code && messages?.[ownId] ? ownId : applicationMessageId(messages, id, code, version);
};
